export const ACCOUNT_TYPE = {
  BRAND: 1,
  RETAILER: 2,
} as const
